import { GA4_EVENT_VIEW_ITEM_LIST } from '@common/Tracking/constants/GaEvents';
import { ga4event } from '@helpers/dataLayer';

export const GA4ViewItemListEvent = (navigationId, baseNavigationId, productsGroup, config) => {
    const { breadcrumbPath } = config.trackingData;

    const itemCategories = breadcrumbPath.split('/');

    const eventData = {};

    const trackingFields = {
        item_list_id: navigationId,
        item_list_name: productsGroup,
        item_category: itemCategories[0],
        item_category2: itemCategories[1],
        item_category3: itemCategories[2],
        item_category4: itemCategories[3],
        item_category5: itemCategories[4],
        ...(baseNavigationId !== navigationId && { path_id: baseNavigationId })
    };

    for (const field in trackingFields) {
        if (trackingFields[field]) {
            eventData[field] = trackingFields[field];
        }
    }

    ga4event(GA4_EVENT_VIEW_ITEM_LIST, eventData);
};
